import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-birthday',
  templateUrl: './events-birthday.component.html',
  styleUrls: ['./events-birthday.component.scss'],
})
export class EventsBirthdayComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/birthday/1.jpg',
      thumbnail: 'assets/img/school/events/birthday/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/2.jpg',
      thumbnail: 'assets/img/school/events/birthday/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/3.jpg',
      thumbnail: 'assets/img/school/events/birthday/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/4.jpg',
      thumbnail: 'assets/img/school/events/birthday/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/5.jpg',
      thumbnail: 'assets/img/school/events/birthday/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/6.jpg',
      thumbnail: 'assets/img/school/events/birthday/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/7.jpg',
      thumbnail: 'assets/img/school/events/birthday/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/8.jpg',
      thumbnail: 'assets/img/school/events/birthday/8.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/birthday/9.jpg',
      thumbnail: 'assets/img/school/events/birthday/9.jpg',
      alt: 'Image 01',
    },
  ];
}
